import api from 'api';
import { setUserPermissions, setFoldersForPermissions } from 'store/slices/dataPermissionsSlice';

export const refreshFoldersPermissions = async (roomId: string, dispatch: any) => {
  try {
    const { data: foldersPermissionsReq } = await api.getFoldersPermissions({ room_id: roomId });
    const rootFolder = foldersPermissionsReq.find((el: any) => el.id === 0);
    const onlyFolders = foldersPermissionsReq.filter((el: any) => el.id !== 0);
    const foldersWithPermissions = onlyFolders || [];
    const foldersWithoutNull = foldersWithPermissions.map((folder: any) => ({
      ...folder,
      permissions: folder.permissions && folder.permissions[0] ? folder.permissions : []
    }));

    dispatch(setUserPermissions({ documents: [], folders: foldersWithoutNull, rootFolder }));
    dispatch(setFoldersForPermissions(
      foldersWithoutNull.map((folder: any) => ({ ...folder, key: `folder ${folder.id}`, type: 'folder' }))
    ));
  } catch (error) {
    console.error('Failed to refresh permissions:', error);
  }
};

